<app-side-menu>
  <div class="b2b-contracts-driver-view-container">
    <!-- Loading State -->
    <app-loading [show]="isLoading" message="Carregando condutor..."></app-loading>

    <!-- Content -->
    <div *ngIf="!isLoading && driver" class="view-content">
      <!-- Header -->
      <div class="header">
        <div class="title-section">
          <button class="btn-back" (click)="navigateBack()">
            <i class="fas fa-arrow-left"></i>
          </button>
          <div class="title-info">
            <h1>
              <i class="fas fa-user me-2"></i>
              {{ driver.name || 'Condutor' }}
            </h1>
            <p *ngIf="contractNumber">
              Contrato: {{ contractNumber }} - {{ contractName }}
            </p>
          </div>
        </div>
        <div class="action-buttons">
          <button
            *appHasPermission="'B2BContracts.Edit'"
            class="btn btn-primary me-2"
            (click)="navigateEdit()">
            <i class="fas fa-edit me-2"></i>
            Editar
          </button>
          <button class="btn btn-secondary" (click)="navigateBack()">
            <i class="fas fa-arrow-left me-2"></i>
            Voltar
          </button>
        </div>
      </div>

      <!-- Informações Pessoais -->
      <div class="card mb-4">
        <div class="card-header text-white">
          <h3>
            <i class="fas fa-user me-2"></i>
            Informações Pessoais
          </h3>
        </div>
        <div class="card-body">
          <div class="row g-3">
            <div class="col-md-6">
              <label class="form-label">Nome</label>
              <p class="form-control-plaintext">{{ driver.name || 'N/A' }}</p>
            </div>
            <div class="col-md-6">
              <label class="form-label">CPF</label>
              <p class="form-control-plaintext">{{ formatCpfCnpj(driver.driverCpf) }}</p>
            </div>
            <div class="col-md-6">
              <label class="form-label">CNH</label>
              <p class="form-control-plaintext">{{ driver.driverCnh || 'N/A' }}</p>
            </div>
            <div class="col-md-3">
              <label class="form-label">Categoria CNH</label>
              <p class="form-control-plaintext">{{ driver.cnhCategory || 'N/A' }}</p>
            </div>
            <div class="col-md-3">
              <label class="form-label">Vencimento CNH</label>
              <p class="form-control-plaintext">{{ formatDate(driver.cnhExpirationDate) }}</p>
            </div>
            <div class="col-md-6">
              <label class="form-label">Telefone</label>
              <p class="form-control-plaintext">{{ formatPhone(driver.phone) }}</p>
            </div>
            <div class="col-md-6">
              <label class="form-label">Email</label>
              <p class="form-control-plaintext">{{ driver.email || 'N/A' }}</p>
            </div>
            <div class="col-md-4">
              <label class="form-label">Matrícula (RH)</label>
              <p class="form-control-plaintext">{{ driver.employeeRegistration || 'N/A' }}</p>
            </div>
            <div class="col-md-4">
              <label class="form-label">Admissão</label>
              <p class="form-control-plaintext">{{ formatDate(driver.admissionDate) }}</p>
            </div>
            <div class="col-md-4">
              <label class="form-label">Nascimento</label>
              <p class="form-control-plaintext">{{ formatDate(driver.birthDate) }}</p>
            </div>
            <div class="col-md-6">
              <label class="form-label">Coordenador</label>
              <p class="form-control-plaintext">{{ driver.coordinatorName || 'N/A' }}</p>
            </div>
            <div class="col-md-6">
              <label class="form-label">Líder</label>
              <p class="form-control-plaintext">{{ driver.leaderName || 'N/A' }}</p>
            </div>
            <div class="col-md-12">
              <label class="form-label">Endereço (legado)</label>
              <p class="form-control-plaintext">{{ driver.address || 'N/A' }}</p>
            </div>
            <div class="col-md-6">
              <label class="form-label">Logradouro</label>
              <p class="form-control-plaintext">{{ driver.addressStreet || 'N/A' }}</p>
            </div>
            <div class="col-md-2">
              <label class="form-label">Número</label>
              <p class="form-control-plaintext">{{ driver.addressNumber || 'N/A' }}</p>
            </div>
            <div class="col-md-4">
              <label class="form-label">Bairro</label>
              <p class="form-control-plaintext">{{ driver.addressNeighborhood || 'N/A' }}</p>
            </div>
            <div class="col-md-3">
              <label class="form-label">CEP</label>
              <p class="form-control-plaintext">{{ driver.addressZipCode || 'N/A' }}</p>
            </div>
            <div class="col-md-5">
              <label class="form-label">Cidade</label>
              <p class="form-control-plaintext">{{ driver.addressCity || 'N/A' }}</p>
            </div>
            <div class="col-md-4">
              <label class="form-label">UF</label>
              <p class="form-control-plaintext">{{ driver.addressState || 'N/A' }}</p>
            </div>
          </div>
        </div>
      </div>

      <app-b2b-driver-documents
        [contractId]="contractId"
        [driverId]="driverId"
        [cnhDocumentUrl]="driver.cnhDocumentUrl"
        [termoResponsabilidadeUrl]="driver.termoResponsabilidadeUrl"
        (documentsUpdated)="onDocumentsUpdated($event)">
      </app-b2b-driver-documents>

      <!-- Associações -->
      <div class="card mb-4" *ngIf="driver.itemAssociations && driver.itemAssociations.length > 0">
        <div class="card-header text-white">
          <h3>
            <i class="fas fa-link me-2"></i>
            Associações com Itens
          </h3>
        </div>
        <div class="card-body">
          <div class="table-responsive">
            <table class="table">
              <thead>
                <tr>
                  <th>Item ID</th>
                  <th>Informações</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let association of driver.itemAssociations">
                  <td>{{ association.itemId || association.ItemId || 'N/A' }}</td>
                  <td>{{ association.info || association.Info || 'N/A' }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</app-side-menu>
